const COMPENSATE_ADDRESS = "0xccfc4315ec85f56a29625E6C383D3D763Ca08891"
const COMPENSATE_TOKEN = "WPSC"
export { COMPENSATE_ADDRESS,COMPENSATE_TOKEN}